export const promote = (config) => ({
    source: { source: 'custom' },
    custom: config.variables
});
//# sourceMappingURL=call-update-variables-1-to-2.js.map